/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type PERIODICITY = "DAILY" | "MONTHLY" | "WEEKLY" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_HOURS" | "FIXED_PRICE" | "TIME_AND_MATERIALS" | "%future added value";
export type CreateRetainerPeriodInput = {
    projectId?: string | null | undefined;
    name?: string | null | undefined;
    startYear?: number | null | undefined;
    startMonth?: number | null | undefined;
    startDay?: number | null | undefined;
    endYear?: number | null | undefined;
    endMonth?: number | null | undefined;
    endDay?: number | null | undefined;
    preCreateAmount?: number | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type createRetainerPeriodMutationVariables = {
    input: CreateRetainerPeriodInput;
};
export type createRetainerPeriodMutationResponse = {
    readonly createRetainerPeriod: {
        readonly retainerPeriod: {
            readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly startYear: number | null;
                readonly startMonth: number | null;
                readonly startDay: number | null;
                readonly endYear: number | null;
                readonly endMonth: number | null;
                readonly endDay: number | null;
                readonly available: number | null;
                readonly periodLength: number | null;
                readonly periodPeriodicity: PERIODICITY | null;
                readonly periodPriceAmount: number | null;
                readonly periodHoursAmount: number | null;
                readonly periodBudgetType: PERIOD_BUDGET_TYPE | null;
                readonly periodSettingIgnoreForBilling: boolean | null;
                readonly periodSettingSubtractValue: boolean | null;
                readonly periodSettingRollValue: boolean | null;
                readonly periodSettingAddExpenses: boolean | null;
                readonly periodDifferencePriceAmount: number | null;
                readonly periodDifferenceHoursAmount: number | null;
                readonly sharedPeriodDifferenceHoursAmount: number | null;
                readonly sharedPeriodDifferencePriceAmount: number | null;
                readonly ignoredRolloverHours: number | null;
                readonly ignoredRolloverPrice: number | null;
                readonly periodLocked: boolean | null;
                readonly periodLockedTime: string | null;
                readonly periodDifferenceSplit: boolean | null;
            } | null;
        } | null;
    } | null;
};
export type createRetainerPeriodMutation = {
    readonly response: createRetainerPeriodMutationResponse;
    readonly variables: createRetainerPeriodMutationVariables;
};



/*
mutation createRetainerPeriodMutation(
  $input: CreateRetainerPeriodInput!
) {
  createRetainerPeriod(input: $input) {
    retainerPeriod {
      node {
        id
        name
        startYear
        startMonth
        startDay
        endYear
        endMonth
        endDay
        available
        periodLength
        periodPeriodicity
        periodPriceAmount
        periodHoursAmount
        periodBudgetType
        periodSettingIgnoreForBilling
        periodSettingSubtractValue
        periodSettingRollValue
        periodSettingAddExpenses
        periodDifferencePriceAmount
        periodDifferenceHoursAmount
        sharedPeriodDifferenceHoursAmount
        sharedPeriodDifferencePriceAmount
        ignoredRolloverHours
        ignoredRolloverPrice
        periodLocked
        periodLockedTime
        periodDifferenceSplit
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateRetainerPeriodInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateRetainerPeriodPayload",
    "kind": "LinkedField",
    "name": "createRetainerPeriod",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RetainerPeriodTypeEdge",
        "kind": "LinkedField",
        "name": "retainerPeriod",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RetainerPeriodType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "available",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodLength",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodPeriodicity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodPriceAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodHoursAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodBudgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodSettingIgnoreForBilling",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodSettingSubtractValue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodSettingRollValue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodSettingAddExpenses",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodDifferencePriceAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodDifferenceHoursAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sharedPeriodDifferenceHoursAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sharedPeriodDifferencePriceAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ignoredRolloverHours",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ignoredRolloverPrice",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodLocked",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodLockedTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "periodDifferenceSplit",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createRetainerPeriodMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createRetainerPeriodMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createRetainerPeriodMutation",
    "operationKind": "mutation",
    "text": "mutation createRetainerPeriodMutation(\n  $input: CreateRetainerPeriodInput!\n) {\n  createRetainerPeriod(input: $input) {\n    retainerPeriod {\n      node {\n        id\n        name\n        startYear\n        startMonth\n        startDay\n        endYear\n        endMonth\n        endDay\n        available\n        periodLength\n        periodPeriodicity\n        periodPriceAmount\n        periodHoursAmount\n        periodBudgetType\n        periodSettingIgnoreForBilling\n        periodSettingSubtractValue\n        periodSettingRollValue\n        periodSettingAddExpenses\n        periodDifferencePriceAmount\n        periodDifferenceHoursAmount\n        sharedPeriodDifferenceHoursAmount\n        sharedPeriodDifferencePriceAmount\n        ignoredRolloverHours\n        ignoredRolloverPrice\n        periodLocked\n        periodLockedTime\n        periodDifferenceSplit\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '6812794c61df99405fb86a6ed41725fa';
export default node;
